// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1sqFf","Success":"Modal_Success__3vdL2","Error":"Modal_Error__3-DGc"};